import React from "react";
import { string, any, bool, func } from "prop-types";
import { Link } from "@quintype/components";

import { SvgIconHandler } from "../SvgIconHandler";

import "./Button.m.css";

const Button = ({
  href,
  children,
  socialButton,
  ariaLabel,
  customStyleName,
  iconType,
  iconWidth,
  iconHeight,
  onClickFunction,
  disableAjaxLinks = true,
  isEventConfigured = false,
  openInNewTab = false,
  isHamburgerbtn = false,
  disabled = false,
  type = "button",
}) => {
  const buttonContent = iconType ? (
    <span styleName="button-content">
      {iconType === "summary" ? <i styleName="summaryicon" /> : iconType === "highlights" ? <i styleName="highlightsicon" /> : iconType === "grid" ? <i styleName="gridview" /> : iconType === "list" ? <i styleName="listview" /> : (
      <SvgIconHandler
        type={iconType}
        width={iconWidth}
        height={iconHeight}
        viewBox={`0 0 ${iconWidth} ${iconHeight}`}
      />
      )}
      {children}
    </span>
  ) : (
    children
  );

  if (socialButton) {
    return (
      <a
        href={href}
        styleName={`btn ${customStyleName} ${isHamburgerbtn ? 'hamburger-adfreebtn' : ''} ${disabled ? "disabled" : ""}`}
        aria-label={ariaLabel}
        onClick={disabled ? undefined : onClickFunction}
        aria-disabled={disabled}
      >
        {children}
      </a>
    );
  }
  if (href && disabled) {
    return (
      <span className="button" styleName={`btn ${customStyleName} disabled`} aria-label={ariaLabel} aria-disabled={true}>
        {buttonContent}
      </span>
    );
  }
  return href ? (
    isEventConfigured ? (
      <Link
        href={href}
        className="button"
        styleName={`btn ${customStyleName}`}
        aria-label={ariaLabel}
        disableAjaxLinks={disableAjaxLinks}
        onMouseDown={onClickFunction}
        onTouchStart={onClickFunction}
        target={openInNewTab ? "_blank" : "_self"}
      >
        {buttonContent}
      </Link>
    ) : (
      <Link
        href={href}
        className="button"
        styleName={`btn ${customStyleName}`}
        aria-label={ariaLabel}
        disableAjaxLinks={disableAjaxLinks}
        target={openInNewTab ? "_blank" : "_self"}
      >
        {buttonContent}
      </Link>
    )
  ) : (
    <button
      className="button"
      styleName={`btn ${customStyleName} ${disabled ? "disabled" : ""}`}
      aria-label={ariaLabel}
      onClick={disabled ? undefined : onClickFunction}
      aria-disabled={disabled}
      type={type || "button"}
    >
      {buttonContent}
    </button>
  );
};

Button.defaultProps = {
  href: "",
  children: "",
  socialButton: false,
  ariaLabel: "button",
  customStyleName: "",
  iconType: "",
  iconWidth: "16",
  iconHeight: "16",
  onClickFunction: () => {},
  disabled: false,
};

Button.propTypes = {
  href: string,
  children: any,
  socialButton: bool,
  ariaLabel: string.isRequired,
  customStyleName: string,
  iconType: string,
  iconWidth: string,
  iconHeight: string,
  onClickFunction: func,
  disableAjaxLinks: bool,
  disabled: bool,
};

export default Button;
